import type { UploaderTriggerRenderProps } from '../types';
import type { ReactNode } from 'react';

import { Icon } from '~/atoms';
import { Button } from '~/molecules';

type P = {
  isDisabled: boolean;
  onOpen: () => void;
  openModalButtonIcon?: ReactNode;
  openModalButtonText: string;
  renderTrigger?: (props: UploaderTriggerRenderProps) => ReactNode;
} & ComponentStyling;

export function UploaderTrigger({
  className,
  isDisabled,
  onOpen,
  openModalButtonIcon,
  openModalButtonText,
  renderTrigger,
  style,
}: P) {
  if (renderTrigger) {
    return renderTrigger({ isDisabled, open: onOpen });
  }

  return (
    <Button
      buttonStyle="secondary"
      className={className}
      disabled={isDisabled}
      icon={openModalButtonIcon ?? <Icon metaphor="add" />}
      onClick={onOpen}
      style={style}
      text={openModalButtonText}
    />
  );
}
